import React from 'react'
import './SimpleInput.scss'

type SimpleInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string
  title?: string
  error?: string
}

class SimpleInput extends React.PureComponent<SimpleInputProps> {
  input: any
  constructor(props: any) {
    super(props)
    this.input = React.createRef()
  }

  render() {
    const { label, title, error, ...rest } = this.props
    const cname = 'SimpleInput-root' + (error ? ' error' : '')
    return (
      <div className={cname}>
        <div className="SimpleInput-main">
          <input ref={this.input} {...rest} className="SimpleInput-input" />
          {label && <div className="SimpleInput-label">{label}</div>}
          <div className="SimpleInput-line">
            <div className="SimpleInput-activeline" />
          </div>
          {error && (
            <div className="SimpleInput-error">
              {title || label} {error}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default SimpleInput
